import fromPairs from 'lodash/fromPairs';

/**
 * All component prop types should extend this and use the componentProps helper
 * so that they support passing through of classes, data and aria attributes.
 */
export type ComponentProps = {
  className?: string;
  id?: string;
};

type TransformedAttributes = {
  className?: string;
  id?: string;
  // Plus 0 or more data and aria attributes
};

/**
 * Function to transform common component attributes (classnames, data attributes, aria attributes) to
 * a new object where they can be directly applied to an html element by spreading.
 *
 * @example <Component {...componentProps(props)}> />
 */
const componentProps = (props: ComponentProps): TransformedAttributes => {
  const dataProps = Object.entries(props).filter(([key]) => key.startsWith('data-'));
  const ariaProps = Object.entries(props).filter(([key]) => key.startsWith('aria-'));

  const transformedProps = {
    ...fromPairs(dataProps),
    ...fromPairs(ariaProps),
  };

  if (props?.id !== undefined) {
    transformedProps.id = props.id;
  }

  if (props?.className !== undefined) {
    transformedProps.className = props.className;
  }

  return transformedProps;
};

export default componentProps;
